import React from 'react';
import './AlertPopup.css';

const AlertPopup = ({ message, type = 'info', onClose }) => {
  const getIcon = () => {
    switch (type) {
      case 'success': return '✅';
      case 'error': return '❌';
      case 'warning': return '⚠️';
      default: return 'ℹ️';
    }
  };

  return (
    <div className="alert-overlay">
      <div className={`alert-popup ${type}`}>
        <div className="alert-icon">{getIcon()}</div>
        <div className="alert-message">{message}</div>
        <button className="alert-close" onClick={onClose}>OK</button>
      </div>
    </div>
  );
};

export default AlertPopup;